export function destroyElement(selector, container) {
    if (container) {
        let el = container.querySelector(selector);

        if (el) {
            el.parentNode.removeChild(el);
        }

        return;
    }

    throw "not implemented";
}

export function onDomContentLoaded(callback) {
    if (document.readyState !== 'loading') {
        callback();
    } else {
        document.addEventListener('DOMContentLoaded', callback);
    }
}
export function getCookie(name) {
    if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(name + "=");

        if (start != -1) {
            start = start + name.length + 1;
            var end = document.cookie.indexOf(";", start);

            if (end == -1) {
                end = document.cookie.length;
            }

            return unescape(document.cookie.substring(start, end));
        }
    }

    return "";
}

export function setCookie(name, value, days) {
    var today = new Date();
    var expire = new Date();

    if (days === null || days === 0) {
        days = 1;
    }

    expire.setTime(today.getTime() + 3600000 * 24 * days);
    document.cookie = name + "=" + escape(value) + ";Secure;SameSite=Lax;Path=/;Expires=" + expire.toGMTString();
}

export function isTouchDevice() {
    return 'ontouchstart' in window;
}

export function screenWidth() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

export function parse(html) {
    let parser = new DOMParser();
    let parsed = parser.parseFromString(html, 'text/html')

    return parsed.querySelector('body').childNodes[0];
}

export function navigateToLocation(href, parent) {
    if (parent !== undefined && parent == 'true') {
        window.parent.internalLinkClicked = true;
        window.parent.location.href = href;
    }
    else {
        window.internalLinkClicked = true;
        window.location.href = href;
    }
}

export function ajax(url, method, data, onSuccess, onFailure, contentType, isSync) {
    var options = url;

    if (typeof url !== 'object') {
        options = {
            url: url,
            method: method,
            data: data,
            success: onSuccess,
            failure: onFailure,
            contentType: contentType,
            async: !isSync
        }
    }

    var request = new XMLHttpRequest();
    var self = this;

    request.addEventListener('load', function () {
        if (request.status === 500 || request.status === 422) {
            options.failure.bind(self)(JSON.parse(request.response));
            return;
        }

        var parsed = request.response;

        if (options.contentType != "text/html") {
            parsed = JSON.parse(parsed);
        }

        options.success.bind(self)(parsed);
    });

    if (options.method.toUpperCase() === 'GET' && options.data != null) {
        var queryString = jsonToQueryString(options.data);
        var connector = queryString.length > 0 ? (options.url.indexOf('?') > -1 ? '&' : '?') : '';
        options.url += connector + queryString;
    }

    request.open(options.method, options.url, options.async);

    var requestData = null;

    options.contentType = options.contentType ? options.contentType : 'application/json';
    request.setRequestHeader("Content-Type", options.contentType);
    request.setRequestHeader("Accept", options.contentType);
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");

    //to support ValidateAntiForgeryToken:
    if (options.contentType.toLowerCase() === 'application/x-www-form-urlencoded' && options.method.toUpperCase() === 'POST') {
        addSecurityToken(options.data);
        if (options.data['__RequestVerificationToken']) {
            request.setRequestHeader('RequestVerificationToken', options.data['__RequestVerificationToken']);
        }
        requestData = jsonToQueryString(options.data);
    }
    else if (options.data && options.method.toUpperCase() !== 'GET') {
        addSecurityToken(options.data);
        if (options.data['__RequestVerificationToken']) {
            request.setRequestHeader('RequestVerificationToken', options.data['__RequestVerificationToken']);
        }
        requestData = JSON.stringify(options.data);
    }
    request.send(requestData);
}

function addSecurityToken(data) {
    if (phe.config.antiForgeryToken && data && !data.__RequestVerificationToken)
        data.__RequestVerificationToken = phe.config.antiForgeryToken;
    return data;
}

export function waitFor(thing, callback) {
    var intervalId = setInterval(function () {
        var things = thing.split(',');
        var passed = true;

        for (var i = 0; i < things.length; i++) {
            if (things[i].indexOf('.') > -1) {
                if (!compoundWait(things[i])) {
                    passed = false;
                    break;
                }
            } else {
                if (!simpleWait(things[i])) {
                    passed = false;
                    break;
                }
            }
        }

        if (passed) {
            clearInterval(intervalId);
            callback();
        }
    }, 10);
    function simpleWait(thing) {
        if (thing && typeof (thing) === "string" && thing["charAt"] && typeof (thing.charAt === "function") && thing.charAt(0) === "#") {
            return !!document.getElementById(thing.substring(1));
        }
        if (window[thing] == undefined) {
            return false;
        }
        return true;
    }
    function compoundWait(thing) {
        var awaited = thing.split('.');
        if (window[awaited[0]] == undefined) {
            return false;
        } else {
            var next = window[awaited[0]];
            for (var i = 1; i < awaited.length; i++) {
                if (next[awaited[i]] == undefined) {
                    return false;
                } else {
                    next = next[awaited[i]];
                }
            }
        }
        return true;
    }
}
export function disableSubmitButton(form) {
    if (form.dataset.disableOnSubmit) {
        Array.from(form.querySelectorAll('[type="submit"]')).map(function (btn) {
            btn.disabled = true;
        });
    }
}
export function showCustomError(form, msg) {
    if (form.querySelector('.alert-validation')) {
        form.querySelector('.alert-validation').classList.remove('hidden');
        form.querySelector('.alert-validation').innerText = msg;
    }
}
export function enableSubmitButton(form) {
    if (form.dataset.disableOnSubmit) {
        Array.from(form.querySelectorAll('[type="submit"]')).map(function (btn) {
            btn.disabled = false;
        });
    }
}

export function delayLoadImages(images) {

    //zoom image has.delayloadimg class. should not load on document.ready
    Array.from(images || [].slice.call(document.querySelectorAll('img[data-src]'))).map(function (img) {
        img.setAttribute('loading', "lazy");
        if (img.classList.contains('delayloadimg')) {
            img.setAttribute('src', img.getAttribute('data-src'));
            img.removeAttribute('data-src');
        }
    });
}

export function triggerEvent(eventName, data) {
    const e = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(e);
}

export function hideNotSafeForRemoteWorkImages() {
    if (phe.config.hideNSFWImages) {
        [].slice.call(document.querySelectorAll("img")).map(function (el) {
            el.style.visibility = "hidden";
        });

        [].slice.call(document.querySelectorAll("*")).map(function (el) {
            el.style.backgroundImage = "none"
        })
    }
}

export function getQueryStringParam(sParam, url) {
    var sPageURL = typeof url !== 'undefined' ? url : window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }
}

export function jsonToQueryString(json) {
    return Object.keys(json).map(function (key) {
        return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key]);
    }).join('&');
}

export function generateErrorMessage(e) {
    var validationError = document.createElement('div');
    validationError.classList.add('text-red');
    var validationErrorText = e.getAttribute('data-error-message');
    if (validationErrorText == null) {
        validationErrorText = e.getAttribute('title') + ' is invalid';
    }
    validationError.appendChild(document.createTextNode(validationErrorText));
    return validationError;
}

export function setCoremetricsItem(iPID, iCategoryID, iItemType, anchor, cancelNav, searchTerm, listIndex) {
    if (!iCategoryID)
        iCategoryID = 0;

    var href = anchor && anchor.getAttribute("href");
    var cookieName = 'cmViewed';
    var cookieValue = getCookie(cookieName) || '';
    try {
        cookieValue = decodeURI(cookieValue);
    } catch (e) { }
    var products = cookieValue.split('&');
    var updatedList = [];
    var delimiter = "_";

    if (cookieValue.length > 0) {
        var index = 0;

        products.forEach(function (v) {
            if (v.split('=').length > 1) {
                var parts = v.split('=')[1];
                var pid = parts.split(delimiter)[0];
                var pItemType = parts.split(delimiter)[1];
                var pCatId = parts.split(delimiter)[2];
                var pSearchTerm = null;
                if (parts.split(delimiter).length > 3)
                    pSearchTerm = parts.split(delimiter)[3];
                var pIndex = null;
                if (parts.split(delimiter).length > 4)
                    pIndex = parts.split(delimiter)[4];

                if (parseInt(pid) !== parseInt(iPID)) {
                    index += 1;
                    updatedList.push('Product' + index + 'ID=' + pid + delimiter + pItemType + delimiter + pCatId + delimiter + pSearchTerm + (pIndex ? (delimiter + pIndex) : ''));
                }
            }
        });
    }
    var decodedSearchTerm = searchTerm ? searchTerm.replace(/%/g, " ").toLowerCase() : searchTerm;
    try {
        decodedSearchTerm = decodedSearchTerm ? decodeURI(decodedSearchTerm) : '';
    } catch (e) { }

    updatedList.push('Product' + (updatedList.length + 1) + 'ID=' + iPID + delimiter + iItemType + delimiter + iCategoryID + delimiter + decodedSearchTerm + (listIndex ? (delimiter + listIndex) : ''));
    cookieValue = updatedList.join('&');
    if (phe.config.cookies.allowPerformanceCookies) {
        document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";Secure;SameSite=Lax;Path=/;";
    }
    if (!cancelNav) {
        //FIRST REMOVE ONCLICK BEFORE RE-CLICKING THE ANCHOR
        anchor.removeAttribute("onclick");

        if (navigator.appName == 'Microsoft Internet Explorer') {
            //WORKS IN IE ONLY  
            setTimeout(function () {
                try {
                    anchor.click();
                }
                catch (e) {
                    //catching all java script exception here since in wizard results page when the user tries to
                    //move away from the page browser would pop an message asking a user if he is sure to leave the page
                    //if user selects yes, then i would throw an exception here "breaking on jscript runtime error jquery is undefined"
                }
            }, 100);
        }
        else {
            ////CAUSES US TO LOSE REFERRER IN IE ONLY WHICH IS NEEDED FOR BREADCRUMBS ON PRODUCT PAGE
            if (href) {
                navigateToLocation(href);
            }
        }
    }
}
window.setCoremetricsItem = setCoremetricsItem;

export function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
export function chunk(arr, size) {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
        arr.slice(i * size, i * size + size)
    );
}
export function removeIllegalCharacters(itemName) {
    var pattern = /[/&'’™`!#:\/<>~;%\$^*"]/g;
    if (itemName && itemName.length > 0) {
        return itemName.replace(pattern, '');
    } else {
        return "";
    }
}

export function ga_trackEvent(eventID, actionType, categoryID, eventLabel) {
   
    if (phe.config.cookies.allowPerformanceCookies) {
        var action = '';
        if (parseInt(actionType) > 0) {
            action = '-' + (parseInt(actionType) === 1 ? 'Initiated' : parseInt(actionType) === 2 ? 'Completed' : actionType)
        }
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'EE_TrackEvent',
                'ee_EventAction': eventID + action,
                'ee_EventCategory': categoryID,
                'ee_EventLabel': eventLabel || ''
            });
        }
    }
}

export function ga_trackGA4EcommEvent(eventName, ecommJSON, includePromotionData, checkout_type) {
    dataLayer.push({ ecommerceGA4: null });
    var ecommObj = JSON.parse(ecommJSON) || {};
  
    ecommObj.checkout_type = eventName == "begin_checkout" && typeof checkout_type != "undefined" ? checkout_type: "";
    if (includePromotionData) {
        var json = window.phe.safeSessionStorage.getItem("select_promotion", { reportFailure: false });
        if (json && json.length) {
            var obj = JSON.parse(json);
            ecommObj.creative_name = obj.creative_name;
            ecommObj.creative_slot = obj.creative_slot;
            ecommObj.promotion_name = obj.promotion_name;
            ecommObj.promotion_id = obj.promotion_id;
        }
    }
        dataLayer.push({
            "event": eventName,
            "ecommerceGA4": ecommObj
        });
}

export function hasObj(o) {
    return typeof o !== "undefined" && o !== null;
}

export function toInt(v, fallback = 0) {
    const n = parseInt(v ?? "", 10);
    return Number.isFinite(n) ? n : fallback;
}

export function isInViewPort(selector) {
    if (document.querySelector(selector)) {
        var bounding = document.querySelector(selector).getBoundingClientRect();
        return bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    } else {
        return false;
    }
}

export async function postJson(url, payload) {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "RequestVerificationToken": phe.config.antiForgeryToken
        },
        credentials: "same-origin",
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
    }

    return await response.json();
}

export function updateUrlParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}
